import { QuestionnaireComponentKind } from '@main/dynamic-form';
import { Field_Types_Enum } from '@main/graphql/types.generated';

const customFieldMapping: Partial<Record<QuestionnaireComponentKind, Field_Types_Enum>> = {
  [QuestionnaireComponentKind.Text]: Field_Types_Enum.Text,
  [QuestionnaireComponentKind.Number]: Field_Types_Enum.Number,
  [QuestionnaireComponentKind.Date]: Field_Types_Enum.Date,
  [QuestionnaireComponentKind.Email]: Field_Types_Enum.Email,
  [QuestionnaireComponentKind.Url]: Field_Types_Enum.Url,
  [QuestionnaireComponentKind.Options]: Field_Types_Enum.Select,
};

export function isCustomFieldForField(
  customFieldType: Field_Types_Enum,
  fieldKind: QuestionnaireComponentKind,
) {
  return customFieldType === customFieldMapping[fieldKind];
}
